import React from 'react'; // React ko SIRF EK BAAR import karein
import ReactDOM from 'react-dom/client';
import './theme.css';
import App from './App';
// import reportWebVitals from './reportWebVitals'; // Optional

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// reportWebVitals(); // Optional